import { Classes as CoreClasses } from "@blueprintjs/core";

/* eslint-disable tree-shaking/no-side-effects-in-initialization */
const NS = CoreClasses.getClassNamespace();
export const TIMEPICKER = `${NS}-timepicker`;
export const TIMEPICKER_ARROW_BUTTON = `${TIMEPICKER}-arrow-button`;
export const TIMEPICKER_ARROW_ROW = `${TIMEPICKER}-arrow-row`;
export const TIMEPICKER_DIVIDER_TEXT = `${TIMEPICKER}-divider-text`;
export const TIMEPICKER_HOUR = `${TIMEPICKER}-hour`;
export const TIMEPICKER_INPUT = `${TIMEPICKER}-input`;
export const TIMEPICKER_INPUT_ROW = `${TIMEPICKER}-input-row`;
export const TIMEPICKER_MILLISECOND = `${TIMEPICKER}-millisecond`;
export const TIMEPICKER_MINUTE = `${TIMEPICKER}-minute`;
export const TIMEPICKER_SECOND = `${TIMEPICKER}-second`;
export const TIMEPICKER_AMPM_SELECT = `${TIMEPICKER}-ampm-select`;

export const Classes = {
  TIMEPICKER,
  TIMEPICKER_ARROW_BUTTON,
  TIMEPICKER_ARROW_ROW,
  TIMEPICKER_DIVIDER_TEXT,
  TIMEPICKER_HOUR,
  TIMEPICKER_INPUT,
  TIMEPICKER_INPUT_ROW,
  TIMEPICKER_MILLISECOND,
  TIMEPICKER_MINUTE,
  TIMEPICKER_SECOND,
  TIMEPICKER_AMPM_SELECT,
};
